import PropTypes from 'prop-types';
import React from 'react';

function Img({ className, src, alt, title, style, aspectRatio, width, height }) {
  const image = (internalStyle = {}) => (
    <img
      className={className}
      src={src}
      alt={alt || ''}
      title={title}
      width={width}
      height={height}
      style={{ ...internalStyle, ...style }}
    />
  );
  if (aspectRatio) {
    return (
      <div style={{ paddingBottom: `${100 / aspectRatio}%`, position: 'relative' }}>
        {image({
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        })}
      </div>
    );
  }
  return image();
}

// We require the use of src and alt, only enforced by react in dev mode
Img.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  alt: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  aspectRatio: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Img;
